<template>
  <el-card>
    <el-tabs v-model="active">
      <template v-for="item in tabs">
        <el-tab-pane
          :key="item.value"
          :label="item.title"
          :name="item.value"
          v-if="authPromise(item.auth)"
        ></el-tab-pane>
      </template>
    </el-tabs>
    <component :is="active"></component>
  </el-card>
</template>

<script>
import cost from './cost.vue'
import target from './target.vue'
export default {
  components: { cost, target },
  data() {
    return {
      active: 'cost',
      tabs: [
        { title: this.$t('stores::products-info::成本配置'), value: 'cost', auth: 'operate-config::cost' },
        { title: this.$t('stores::products-info::目标配置'), value: 'target', auth: 'operate-config::target' },
      ],
    }
  },
  created() {
    if (this.authPromise('operate-config::target')) {
      this.active = 'target'
    }
    if (this.authPromise('operate-config::cost')) {
      this.active = 'cost'
    }
  },
  activated() {
    if (this.$route.query.type === 'target' && this.authPromise('operate-config::target')) {
      this.active = 'target'
    }
  },
}
</script>

<style scoped lang="scss"></style>
